import { Button, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import { HireCalendar } from '../Fields/HireCalendar';
import './Steps.scss';
import dayjs, { Dayjs } from 'dayjs';
import { IRecruitmentDateSlot } from '../../Services/ResponseData';
import useWindowDimensions from '../../Services/UseWindowDimensions';

interface IState {
    freeSlots?: IRecruitmentDateSlot[],
    selectedSlot?: IRecruitmentDateSlot,
    loadSelect: boolean
}

interface IProps {
    endAction: () => void
    selectedSlotId: number
}


export default function OfferStep(props: IProps): JSX.Element {
    const { height, width } = useWindowDimensions();
    return <SelectHireDateStepInner {...props} width={width} />
}

class SelectHireDateStepInner extends React.Component<IProps & { width: number }, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;


    componentDidMount(): void {
        if (this.props.selectedSlotId > 0) {
            new WebService(this.context.token).GetSlot(this.props.selectedSlotId)
                .then(res => {
                    const slot: IRecruitmentDateSlot = { slotId: res.slotId, slotDate: dayjs(res.slotDate).toDate(), time: res.beginTime, managerName: res.managerName };
                    this.setState({ selectedSlot: slot, freeSlots: [slot] });
                });
        }
        else {
            new WebService(this.context.token).GetFreeSlots()
                .then(res => {
                    this.setState({ freeSlots: res.map(slot => ({ slotId: slot.slotId, slotDate: dayjs(slot.slotDate).toDate(), time: slot.beginTime, managerName: slot.managerName })) })
                });
        }
    }

    private OnAccept() {
        this.setState({ loadSelect: true });
        if (!!this.state.selectedSlot)
            new WebService(this.context.token).SelectSlot(this.state.selectedSlot?.slotId).then(_ => { this.props.endAction(); this.setState({ loadSelect: true }); });
    }

    render(): React.ReactNode {
        return <div className='hireDateStep'>
            <Typography variant='h2' className='step-title'>Выберите  желаемую дату и время выхода</Typography>
            {this.props.width >= 750 && <Typography variant='body16'><b>Важно!</b> Обратите внимание что слоты выбираются по <b>московскому</b> времени.</Typography>}
            {!!this.state && !!this.state.freeSlots && <>
                <div style={{ marginTop: '20px' }}>
                    <HireCalendar
                        onSelect={val => this.setState({ selectedSlot: val })}
                        freeSlots={this.state.freeSlots}
                        value={this.state.selectedSlot}
                        isMobile={this.props.width < 750}
                    />
                </div>
                {this.props.selectedSlotId < 0 && <div className='actionsSection'>
                    {<Button disabled={!this.state.selectedSlot || this.state.loadSelect} onClick={() => { this.OnAccept() }}>Подтвердить</Button>}
                    {this.state.selectedSlot &&
                        <div className='dateCaption'>
                            <Typography variant='caption12'>Дата выхода</Typography>
                            <Typography>{dayjs(this.state.selectedSlot.slotDate).format("DD.MM.YYYY")} в {this.state.selectedSlot.time}</Typography></div>}
                </div>}</>}
        </div>
    }
}